import { Alert } from "@mui/material"

import GestaoVagaFilaAlertaProximidade from "./GestaoVagaFilaAlertaProximidade.jsx"
import GestaoVagaFilaPrazoStatus from "./GestaoVagaFilaPrazoStatus.jsx"
import {
	estaAtrasadoParaFila,
	isMotivoProximidade,
	resolverMotivoTipo,
	simplificarMotivoFila,
} from "./gestaoVagaFilaUi.js"

export default function GestaoVagaFilaDetalheTopo({
	vaga,
	onAtualizarLocalizacao,
	atualizandoGeo = false,
	onErroGps,
}) {
	if (!vaga) return null

	const motivoTipo = resolverMotivoTipo(vaga)
	const mostrarMotivoGenerico =
		Boolean(vaga.motivo) &&
		!vaga.podeEntrarFila &&
		!vaga.naFila &&
		!estaAtrasadoParaFila(vaga) &&
		!isMotivoProximidade(vaga) &&
		!["prazo_encerrado", "jornada_encerrada", "aguardando", "reentrada_fila"].includes(motivoTipo)

	return (
		<div className="gv-fila-detalhe-topo mb-3">
			{vaga.jornadaHoje && vaga.horarioHoje ? (
				<p className="gv-fila-detalhe-topo__jornada m-0 mb-2">
					<strong>Hoje:</strong> {vaga.horarioHoje}
				</p>
			) : null}

			<GestaoVagaFilaPrazoStatus vaga={vaga} />

			<GestaoVagaFilaAlertaProximidade
				vaga={vaga}
				onAtualizarLocalizacao={onAtualizarLocalizacao}
				atualizandoGeo={atualizandoGeo}
				onErroGps={onErroGps}
			/>

			{vaga.naFila ? (
				<Alert severity="success" className="gv-alert-linha-toda mb-0">
					Posição <strong>{vaga.posicaoFila}</strong> de <strong>{vaga.totalNaFila}</strong>
					{vaga.entrouEm ? ` · desde ${vaga.entrouEm}` : ""}
				</Alert>
			) : null}

			{mostrarMotivoGenerico ? (
				<Alert severity="warning" className="gv-alert-linha-toda mb-0">
					{simplificarMotivoFila(vaga)}
				</Alert>
			) : null}
		</div>
	)
}
